export default __webpack_public_path__ + "static/media/1034.d1df77e8.png";